import React from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { BRAND, BRAND_RADIUS } from '../../theme/brandTokens';
import useBrandPalette from '../../theme/useBrandPalette';

const cardBaseSx = {
  borderRadius: BRAND_RADIUS.card,
  background: BRAND.surface,
  border: '1px solid',
  borderColor: BRAND.line,
  overflow: 'hidden',
  height: '100%',
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

// `color` must be a concrete colour (alpha() maths); defaults to the store accent.
const StoreCustomerMetricCard = ({ icon, label, value, caption, color, delay = 0 }) => {
  const brand = useBrandPalette();
  const tint = color || brand.accent;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay }}
      style={{ height: '100%' }}
    >
      <Box sx={cardBaseSx}>
        <Typography
          variant="body2"
          title={label}
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            lineHeight: 1.25,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0 }}>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              flexShrink: 0,
              bgcolor: alpha(tint, 0.12),
              color: tint,
              '& .MuiSvgIcon-root': { fontSize: '1.1rem' },
            }}
          >
            {icon}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h5"
              component="p"
              sx={{
                fontWeight: 700,
                color: BRAND.text,
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: { xs: '1.15rem', sm: '1.5rem' },
              }}
            >
              {value}
            </Typography>
            {caption ? (
              <Typography
                variant="caption"
                sx={{ color: 'text.secondary', display: 'block', mt: 0.25 }}
              >
                {caption}
              </Typography>
            ) : null}
        </Box>
      </Stack>
    </Box>
  </motion.div>
  );
};

export default StoreCustomerMetricCard;
